<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb v-if="!topNav" id="breadcrumb-container" class="breadcrumb-container" />
    <top-nav v-if="topNav" id="topmenu-container" class="breadcrumb-container" />

    <div class="right-menu">
      <div class="navSelect">
        <el-form :inline="true">
          <el-form-item label="当前">
            <el-select v-model="url" class="el-select-nav" size="small" placeholder="请选择" :disabled="!canSwitchEnv" @change="envChange">
              <el-option
                v-for="item in urls"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile/index">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import Search from '@/components/HeaderSearch'

export default {
  components: {
    Breadcrumb,
    TopNav,
    Hamburger,
    Screenfull,
    Search
  },
  data() {
    return {
      env: '',
      urls: [
        { label: 'BestGO 测试服', value: 'https://admin.ninthart.vip' },
        { label: 'BestGO 正式服', value: 'https://admin.prod.ninthart.vip' },
        { label: 'LudoPolyGo 正式服', value: 'https://ludogo.ninthart.vip' },
        { label: 'Fruit Blast Party 正式服', value: 'https://admintetris.ninthart.vip' },
        { label: 'Wild Dice 正式服', value: 'https://adminwilddice.ninthart.vip' },
        { label: '内网', value: 'http://localhost:8082/' }
      ],
      url: ''
    }
  },
  mounted() {
    this.getEnv()
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'roles'
    ]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav
      }
    },
    canSwitchEnv() {
      return !this.roles.includes('marketing')
    }

  },
  methods: {
    getEnv() {
      this.env = process.env.VUE_APP_ENV
      if (this.env === 'development') {
        this.url = 'http://localhost:8082/'
      } else {
        if (this.env === 'test') {
          this.url = 'https://adminwilddice.ninthart.vip'
        } else {
          this.url = 'https://adminwilddice.ninthart.vip'
        }
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    envChange(url) {
      this.$confirm('该操作切换服务器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$store.dispatch('user/getInfo').then(res => {
        //   if (res.code === 200) {
        //     window.open(url + `?token=${res.data.token}&username=${res.data.name}`, '_blank')
        //   } else {
        window.open(url, '_blank')
        // }
        // })
      })

      this.getEnv()
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/LogOut').then(() => {
          location.reload()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navSelect{
  position: absolute;
  top: 2px;
  right: 10px;
  border:1px salmon;
  width: 400px;
  height: 50px;
  .el-select-nav{
    width:200px;
    margin-top: 5px;
  }
}

@media (max-width: 768px){ /*0~768*/
  .navSelect{
    right: -80px;
    width: 300px;
    .el-select-nav{
      width:95px;
      margin-top: 5px;
    }
  }
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 15px;
          font-size: 12px;
        }
      }
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
